import { render } from "./ListExtraService.vue?vue&type=template&id=2c0567f3&scoped=true"
import script from "./ListExtraService.vue?vue&type=script&lang=js"
export * from "./ListExtraService.vue?vue&type=script&lang=js"

import "./ListExtraService.vue?vue&type=style&index=0&id=2c0567f3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0567f3"]])

export default __exports__